import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import InstallAppPrompt from "@/components/InstallAppPrompt";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Browse from "@/pages/Browse";
import ProfileDetail from "@/pages/ProfileDetail";
import MyProfile from "@/pages/MyProfile";
import Interests from "@/pages/Interests";
import Messages from "@/pages/Messages";
import Plans from "@/pages/Plans";
import Shortlist from "@/pages/Shortlist";
import Admin from "@/pages/Admin";
import AdminEnterprise from "@/pages/AdminEnterprise";
import AdminCandidate from "@/pages/AdminCandidate";
import Invite from "@/pages/Invite";
import Welcome from "@/pages/Welcome";
import About from "@/pages/About";
import Stories from "@/pages/Stories";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import SafeMatch from "@/pages/SafeMatch";
import Report from "@/pages/Report";
import Refund from "@/pages/Refund";

import "@/App.css";

function Shell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-brand-bone">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <InstallAppPrompt />
        <Routes>
          <Route path="/" element={<Shell><Landing /></Shell>} />
          <Route path="/login" element={<Shell><Login /></Shell>} />
          <Route path="/register" element={<Shell><Register /></Shell>} />
          <Route path="/plans" element={<Shell><Plans /></Shell>} />
          <Route path="/about" element={<Shell><About /></Shell>} />
          <Route path="/stories" element={<Shell><Stories /></Shell>} />
          <Route path="/contact" element={<Shell><Contact /></Shell>} />
          <Route path="/privacy" element={<Shell><Privacy /></Shell>} />
          <Route path="/terms" element={<Shell><Terms /></Shell>} />
          <Route path="/safe-match" element={<Shell><SafeMatch /></Shell>} />
          <Route path="/refund" element={<Shell><Refund /></Shell>} />
          <Route path="/report" element={<Shell><Report /></Shell>} />
          <Route path="/dashboard" element={<ProtectedRoute><Shell><Dashboard /></Shell></ProtectedRoute>} />
          <Route path="/browse" element={<ProtectedRoute><Shell><Browse /></Shell></ProtectedRoute>} />
          <Route path="/profile/:id" element={<ProtectedRoute><Shell><ProfileDetail /></Shell></ProtectedRoute>} />
          <Route path="/my-profile" element={<ProtectedRoute><Shell><MyProfile /></Shell></ProtectedRoute>} />
          <Route path="/interests" element={<ProtectedRoute><Shell><Interests /></Shell></ProtectedRoute>} />
          <Route path="/messages" element={<ProtectedRoute><Shell><Messages /></Shell></ProtectedRoute>} />
          <Route path="/messages/:partnerId" element={<ProtectedRoute><Shell><Messages /></Shell></ProtectedRoute>} />
          <Route path="/shortlist" element={<ProtectedRoute><Shell><Shortlist /></Shell></ProtectedRoute>} />
          <Route path="/invite" element={<ProtectedRoute><Shell><Invite /></Shell></ProtectedRoute>} />
          <Route path="/welcome" element={<ProtectedRoute><Shell><Welcome /></Shell></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute staffOnly><Shell><AdminEnterprise /></Shell></ProtectedRoute>} />
          <Route path="/admin/candidate/:id" element={<ProtectedRoute staffOnly><Shell><AdminCandidate /></Shell></ProtectedRoute>} />
          <Route path="/admin/legacy" element={<ProtectedRoute adminOnly><Shell><Admin /></Shell></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
